import { useEffect, useState } from "react";

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedVaue] = useState(value)

    useEffect(() => {
        const handle = setTimeout(() => {
            setDebouncedVaue(value)
        }, delay);


        return () => {
            clearTimeout(handle)
        }
    }, [value, delay])
    return debouncedValue
}
export default useDebounce

